<template>
    <div :class="$style.locale_switchers">
        <LocaleSwitcher
            v-for="{ locale, href, isSelected } in locales"
            :key="locale"
            :locale="locale"
            :href="href"
            :isSelected="isSelected"
            @click="updateLocale"
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useLocalizedRouters } from '@/composables/localized-routers'
import { useI18nAddon } from '@/i18n/i18n'
import type { AvailableLocale } from '@/i18n/types'
import { ROUTE_NAMES } from '@/router/constants'
import { updateLocaleCookie } from '@/utils/cookie-parser'

import LocaleSwitcher from './LocaleSwitcher.vue'

const { languageLinks } = defineProps<{
    languageLinks?: Record<AvailableLocale, string>
}>()

const i18nAddon = useI18nAddon()
const { getLocalizedUrls } = useLocalizedRouters()
const route = useRoute()
const isNoLocaleInRoute = computed(() => route.meta.noLocaleInRoute)

const locales = computed(() => {
    const supportedLocales = i18nAddon.getSupportedLocales()
    const urls =
        languageLinks ||
        (isNoLocaleInRoute.value ? getLocalizedUrls({ forRoute: { name: ROUTE_NAMES.MAIN } }) : getLocalizedUrls())
    return supportedLocales.map((locale) => {
        return {
            href: urls[locale],
            locale,
            isSelected: locale === i18nAddon.currentLocale.value,
        }
    })
})

function updateLocale(locale: AvailableLocale) {
    if (locale !== i18nAddon.currentLocale.value) {
        i18nAddon.setPreferredLocale(locale)
        updateLocaleCookie(locale)
    }
}
</script>

<style module>
.locale_switchers {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>
